import React, { Component } from "react";
import DropdownTreeSelect from "react-dropdown-tree-select";
import isEqual from "lodash/isEqual";

export default class HierarchyDropdownForRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: HierarchyDropdownForRole.markSelectedNodes(props.data, props.value),
    };
  }

  // ── Static helper: pure function, never mutates input ──────────────────────
  static markSelectedNodes(nodes, selectedValues) {
    if (!nodes) return nodes;

    // Resolve selected IDs into a Set for O(1) lookup
    let selectedIds = new Set();
    if (typeof selectedValues === "string") {
      selectedValues.split(",").filter(Boolean).forEach((id) => selectedIds.add(id));
    } else if (Array.isArray(selectedValues)) {
      selectedValues.forEach((v) => {
        const id = v?.id ?? v?.value ?? v;
        if (id != null) selectedIds.add(String(id));
      });
    }

    const markNode = (node) => {
      // Always create a new object – never mutate the original
      const newNode = { ...node };
      newNode.checked = selectedIds.has(String(node.id));

      if (newNode.children && newNode.children.length > 0) {
        newNode.children = newNode.children.map(markNode);
        newNode.expanded = newNode.children.some((c) => c.checked || c.expanded);
      }

      return newNode;
    };

    return nodes.map(markNode);
  }

  // ── Replace deprecated componentWillReceiveProps ───────────────────────────
  // getDerivedStateFromProps runs on every render; we only update state when
  // incoming data or value props actually differ from what we last rendered.
  static getDerivedStateFromProps(nextProps, prevState) {
    // We compare against prevState._sourceData / _sourceValue to avoid
    // recomputing on every render when nothing changed.
    const dataChanged = !isEqual(nextProps.data, prevState._sourceData);
    const valueChanged = !isEqual(nextProps.value, prevState._sourceValue);

    if (dataChanged || valueChanged) {
      return {
        data: HierarchyDropdownForRole.markSelectedNodes(nextProps.data, nextProps.value),
        _sourceData: nextProps.data,
        _sourceValue: nextProps.value,
      };
    }

    return null; // no state update needed
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !isEqual(nextState.data, this.state.data) ||
      nextProps.disabled !== this.props.disabled
    );
  }

  handleChange = (currentNode, selectedNodes) => {
    if (this.props.onChange) {
      this.props.onChange(currentNode, selectedNodes);
    }
  };

  render() {
    // Destructure only what we don't want forwarded to DropdownTreeSelect
    const { disabled, value, data, onChange, ...rest } = this.props;

    return (
      <div
        style={{
          color: disabled ? "#6c759d" : "",
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? "none" : "auto",
          borderRadius: "4px",
        }}
      >
        <DropdownTreeSelect
          data={this.state.data}
          onChange={this.handleChange}
          {...rest}
        />
      </div>
    );
  }
}